import { call, put, select, takeLatest } from 'redux-saga/effects'
import apiCall from '../helpers/apiCall'
import { GET } from '../consts/methods'
import { SET_LOADER } from 'dealer-reducers'
import { FETCH_CLIENTS, FETCH_CLIENTS_SUCCESS, FETCH_CLIENTS_FAILURE, Client } from 'src/redux/clientsReducer'
import { RootReducer } from 'src/redux/rootReducer'

interface Response {
  total_pages: number
  total_count: number
  clients: Client[]
  page: number
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function* FetchClientsFlow(): Generator<any, void, any> {
  try {
    yield put(SET_LOADER(true))
    const endpoint = '/dealers_api/clients'
    const currentPage = yield select((state: RootReducer) => state.clientsReducer.currentPage)
    const searchTerm = yield select((state: RootReducer) => state.clientsReducer.searchTerm)
    const response: Response = yield call(apiCall, {
      endpoint,
      api: 'market-api',
      method: GET,
      params: {
        page: currentPage,
        query: searchTerm
      }
    })
    yield put(
      FETCH_CLIENTS_SUCCESS({
        clients: response.clients,
        totalPages: response.total_pages,
        totalCount: response.total_count
      })
    )
  } catch (error) {
    yield put(FETCH_CLIENTS_FAILURE())
  } finally {
    yield put(SET_LOADER(false))
  }
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export default function* FetchClientsSaga(): Generator<any, void, any> {
  yield takeLatest(FETCH_CLIENTS, FetchClientsFlow)
}
